import { createAction, props } from '@ngrx/store';

const ACTION_KEY = '[Main Header]';

export const loadCount = createAction(`${ACTION_KEY} load count`);

export const loadCountSuccess = createAction(
  `${ACTION_KEY} Load count success`,
  props<{ inboxCount: number; favoriteCount: number }>(),
);

export const loadCountFail = createAction(`${ACTION_KEY} Load count fail`);
